export { default } from "./table-columns";
